import { CognitoUser } from 'amazon-cognito-identity-js';

export class User {

    constructor(cognitoUser: CognitoUser){
        this._cognitoUser = cognitoUser;
        this.username = cognitoUser.getUsername();
    }
  
    private _cognitoUser!: CognitoUser;
    private _username!: string;

    public get cognitoUser(): CognitoUser {
        return this._cognitoUser;
    }
    public set cognitoUser(value: CognitoUser) {
        this._cognitoUser = value;
    }
    public get username(): string {
        return this._username;
    }
    public set username(value: string) {
        this._username = value;
    }  
}